export const calcDepositPercent = (savingsInfoArr) => {
    let totalMonthlyAmt = 0;
    for (let i=0; i< savingsInfoArr.length; i++){
       totalMonthlyAmt += +savingsInfoArr[i].monthlyDepositAmt;
    }
    
    for (let i=0; i<savingsInfoArr.length; i++){
        const monthlyDepositAmt = savingsInfoArr[i].monthlyDepositAmt;
        const depositPercent = (+monthlyDepositAmt / +totalMonthlyAmt) * 100
        savingsInfoArr[i].depositPercent = depositPercent.toFixed(2);
    }   
    return totalMonthlyAmt;
}
export default calcDepositPercent;